import Box from '@mui/material/Box';
import { Form } from 'components/@shared/Form/Form';
import Stack from '@mui/material/Stack';
import { FormTextField } from 'components/@shared/Form/TextField';
import { FormPatternTextField } from 'components/@shared/Form/FormPatternTextField';
import { GoBackButton } from 'components/@shared/GoBackButton';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import { FormGoogleAutocomplete } from 'components/@shared/Form/FormGoogleAutocomplete';
import { FormDateTimePicker } from 'components/@shared/Form/FormDateTimePicker';
import { AppointmentFormData } from 'types/appointment';
import { validationSchema } from './validation';
import { initialValues } from './constants';
import { AppointmentAttachmentSection } from './Attachments';
import moment from 'moment';
import { TimeView } from '@mui/x-date-pickers';

interface Props {
    initialData?: AppointmentFormData;
    disabledDateTime?: boolean;
    onCreate: (values: AppointmentFormData) => void;
}

const afterOneHour = moment().add(1, 'hour');
const shouldDisableTime = (value: moment.Moment, view: TimeView) => {
    console.log('day', moment(value).weekday());
    if (moment(value).weekday() === 6 || moment(value).weekday() === 0) {
        return view === 'hours' && (value.hour() >= 22 || value.hour() < 9);
    }
    return view === 'hours' && (value.hour() >= 22 || value.hour() < 16);
};

export const CreateAppointmentForm = ({ initialData = initialValues, disabledDateTime, onCreate }: Props) => {
    return (
        <Form initialValues={initialData} validationSchema={validationSchema} onSubmit={onCreate}>
            <Stack gap={2} pt={3} pb={3} maxWidth={1000} mx="auto">
                <FormTextField name="firstName" label="First Name" fullWidth size="small" />
                <FormTextField name="lastName" label="Last Name" fullWidth size="small" />
                <FormPatternTextField
                    format="###-###-####"
                    mask="_"
                    name="phoneNumber"
                    label="Phone"
                    fullWidth
                    size="small"
                />
                <FormTextField name="email" label="Email" fullWidth size="small" />
                <FormTextField name="title" label="Title" fullWidth size="small" />
                <FormTextField name="description" label="Description" fullWidth size="small" />
                <FormDateTimePicker
                    name="scheduledDateTime"
                    label="Date and time"
                    minDateTime={afterOneHour}
                    shouldDisableTime={shouldDisableTime}
                    disabled={disabledDateTime}
                />
                <FormGoogleAutocomplete name="address" />
                <FormTextField name="houseDescription" label="House description" fullWidth size="small" />
                <Divider />
                <AppointmentAttachmentSection />
                <Box display="flex" justifyContent="space-between" alignItems="center" mt={3}>
                    <GoBackButton />
                    <Button variant="contained" type="submit">
                        Save
                    </Button>
                </Box>
            </Stack>
        </Form>
    );
};
